import React from 'react';
import { Skeleton } from 'antd';
import Wrapper from './style';

const Index = (props) => {
  const { children, totalSteps, currentStep, title, stepTitle, isLoading } =
    props;
  return (
    <Wrapper totalSteps={totalSteps} currentStep={currentStep}>
      <div className="font-subtitle1_medium black1">{title}</div>
      {isLoading && <Skeleton />}
      {!isLoading && (
        <>
          <div className="component_connect_steps">
            <div className="font-paragraph_medium orange1">{`Step ${currentStep}`}</div>
            <div className="font-paragraph black1">{stepTitle}</div>
          </div>
          {children}
        </>
      )}
    </Wrapper>
  );
};

export default Index;
